import { IconType, SvgIcon } from './SvgIcon';

export const WavesOutlineIcon: IconType = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <g
      stroke="currentColor"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4.5 10.5V13.5" />
      <path d="M8.25 7.5V16.5" />
      <path d="M12 4.5V19.5" />
      <path d="M15.75 7.5V16.5" />
      <path d="M19.5 10.5V13.5" />
    </g>
  </SvgIcon>
);

WavesOutlineIcon.displayName = 'WavesOutlineIcon';
